// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__W507D","modalFooterButton":"ModalNotes_modalFooterButton__2C7Ui"};